import { render, staticRenderFns } from "./productDirectoryApply.vue?vue&type=template&id=9bc40502&scoped=true"
import script from "./productDirectoryApply.vue?vue&type=script&lang=js"
export * from "./productDirectoryApply.vue?vue&type=script&lang=js"
import style0 from "./productDirectoryApply.vue?vue&type=style&index=0&id=9bc40502&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bc40502",
  null
  
)

export default component.exports